import React from 'react'

function closeCircle(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="8" fill="white"/>
      <path d="M5 4.66602L11.6667 11.3327" stroke="#6B7073" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5 11.334L11.6667 4.66732" stroke="#6B7073" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default closeCircle